export default "/Frontend/dist/event-background-grey.62cab507874d5c5f29befcd057c47fbe.svg";